import { theme } from "themes/default/theme"

export const styles = {
  main: {
    p: 1,
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  key: {
    width: 35,
    height: 35,
    borderRadius: "4px",
    backgroundColor: "#FAFAFA",
    lineHeight: "35px",
    textTransform: "none",
    fontSize: 16,
    mr: 0.625,
    borderColor: "#CCCCCC",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "scale(1.1)",
      borderColor: "#CCCCCC",
      backgroundColor: "#FAFAFA",
    },
  },
  accent: {
    position: "relative",
    "& :before": {
      content: '"´"',
      position: "absolute",
      right: 12,
      fontSize: 30,
      top: 15,
      lineHeight: 0,
    },
  },
}
